import type { Board } from 'chessboard/model/board/types';
import { StateMachine } from 'chessboard/core/state/config/types';

/**
 * Cancel the promotion and return to the idle state.
 */
export function cancelPromotion({
  context,
  params: { draggingPiece },
  UpdateParams,
}: StateMachine.TransitionParams) {
  const { renderer } = context;

  UpdateParams.dropPiece();
  UpdateParams.cancelPromotion();

  renderer?.dropPiece(<Board.SanSquare>draggingPiece, context);
  renderer?.closePromotionWindow(context);

  return StateMachine.States.Idle;
}
